import { Result } from 'antd';
import { useTranslation } from 'react-i18next';

import EmptyResultIcon from 'assets/images/benefits/surgery-classification/empty-result-icon.svg';
import { PrimaryButton } from 'components';
import { useNavigate } from 'react-router-dom';

function NoResult() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Result
      icon={<img src={EmptyResultIcon} />}
      title={t('benefits.surgery.noResult')}
      subTitle={t('benefits.surgery.makeInquiry')}
      extra={
        <PrimaryButton
          style={{ marginTop: '1.5rem' }}
          onClick={() => navigate('/benefits/surgery-classification/enquiry')}
        >
          {t('benefits.surgery.makeInquiryButton')}
        </PrimaryButton>
      }
    />
  );
}

export default NoResult;
